import { cn } from '@/lib/utils'

interface MarkProps {
  className?: string
  size?: number
}

export function SophiaMark({ className, size = 32 }: MarkProps) {
  return (
    <svg
      viewBox="0 0 32 32"
      width={size}
      height={size}
      className={cn('shrink-0', className)}
      aria-label="Soph.IA"
      role="img"
    >
      <rect width="32" height="32" rx="8" fill="var(--brand-600)" />
      <text
        x="50%"
        y="56%"
        textAnchor="middle"
        dominantBaseline="middle"
        fontFamily="Nunito, sans-serif"
        fontWeight={800}
        fontSize={16}
        fill="var(--accent-50)"
      >
        S
      </text>
    </svg>
  )
}

export function SophiaWordmark({ className }: { className?: string }) {
  return (
    <div className={cn('flex items-center gap-2', className)}>
      <SophiaMark size={28} />
      <span className="font-display font-bold text-lg text-fg-1 tracking-tight">
        Soph<span className="text-brand-600">.</span>IA
      </span>
    </div>
  )
}
